import { createFileRoute } from '@tanstack/react-router'
import { ChannelPage } from '../../components/channel-page'

export const Route = createFileRoute('/_app/c/$slug')({
  validateSearch: (s: Record<string, unknown>): { thread?: string } => (typeof s.thread === 'string' ? { thread: s.thread } : {}),
  component: () => {
    const { slug } = Route.useParams()
    const { me } = Route.useRouteContext()
    return <ChannelPage slug={slug} me={me} />
  },
})
